import React from 'react'
import { ParsedAnchorValue, SelectValue, withParsedContext } from '../../withJSSContext'
import { TextBanner } from '@christies/react/components/Banners'
import { RenderFields } from '../../utils'
import { track, TrackingEvents } from '@christies/react/dist/lib/utils'

interface Props {
  parsedFields: {
    Title: string
    'Secondary Title': string
    'Button Label': string
    'Button Link': ParsedAnchorValue
    'Button Interaction Destination': string
    'Button Interaction Location': string
    'Button Interaction Type': string
  }
  parsedParams: {
    'Button Variant': SelectValue<'primary' | 'secondary'>
    'Component Theme': SelectValue<'light' | 'grey' | 'dark'>
  }
}

const MagazinesTextBannerModule: React.FC<Props> = ({ parsedFields, parsedParams }) => {
  const type = parsedFields?.['Button Interaction Type'] || ''
  const location = parsedFields?.['Button Interaction Location'] || ''
  const destination = parsedFields?.['Button Interaction Destination'] || ''

  const textBannerProps = {
    title: parsedFields?.Title,
    subtitle: parsedFields?.['Secondary Title'],
    theme: parsedParams?.['Component Theme']?.key,
    cta: {
      children: parsedFields?.['Button Label'],
      href: parsedFields?.['Button Link']?.href,
      target: parsedFields?.['Button Link']?.target,
      variant: parsedParams?.['Button Variant']?.key,
      onClick: (): void => {
        if (type || location || destination) {
          track({
            event: TrackingEvents.INTERACTION,
            data: {
              interaction: {
                type,
                location,
                destination,
              },
            },
          })
        }
      },
    },
  }

  return (
    <RenderFields parsedFields={parsedFields}>
      <TextBanner {...textBannerProps} componentName="text-banner" />
    </RenderFields>
  )
}

export default withParsedContext(MagazinesTextBannerModule as React.FC)
